import { SvgIconProps, SvgIcon } from '@material-ui/core';
import * as React from 'react';

export type HashtagIconProps = SvgIconProps;

export function HashtagIcon(props: HashtagIconProps): JSX.Element {
    return (
        <SvgIcon {...props}>
            <path
                clipRule="evenodd"
                d="M5 5V19H19V5L5 5ZM3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z"
                fillRule="evenodd"
                xmlns="http://www.w3.org/2000/svg"
            />
            <path
                clipRule="evenodd"
                d="M11 7H9V9H7V11H9V13H7V15H9V17H11V15H13V17H15V15H17V13H15V11H17V9H15V7H13V9H11V7ZM13 11H11V13H13V11Z"
                fillRule="evenodd"
                xmlns="http://www.w3.org/2000/svg"
            />
        </SvgIcon>
    );
}
HashtagIcon.displayName = 'HashtagIcon';
